/**
 * @fileoverview AR-924 — Which of the three drawer layouts applies: nothing submitted, a teacher upload
 * (editable) or the student's own submission (read-only — the backend answers 422 to any teacher write).
 */

import type { TaskTrackDeliverable, TaskTrackDeliveryStatus } from '../../types'

export type SubmissionMode = 'not_submitted' | 'teacher' | 'student'

/** Mirrors the backend: only a `done` delivery counts (an `open` one is the student's throwaway draft). */
export function isSubmitted(data: TaskTrackDeliverable | null): boolean {
  return data?.delivery?.status === 'done'
}

export function submissionMode(data: TaskTrackDeliverable | null): SubmissionMode {
  if (!isSubmitted(data)) return 'not_submitted'
  return data?.delivery?.uploadedBy ? 'teacher' : 'student'
}

/** Prefers the backend's `deliveryStatus`; derives it from `late` on older payloads. */
export function deliveryStatusOf(data: TaskTrackDeliverable | null): TaskTrackDeliveryStatus {
  if (data?.deliveryStatus) return data.deliveryStatus
  if (!isSubmitted(data)) return 'not_submitted'
  return data?.delivery?.late ? 'late' : 'on_time'
}

/** Task due date (`YYYY-MM-DD`) — the default "work completed on". */
export function dueDayOf(data: TaskTrackDeliverable | null): string | null {
  const date = data?.task.date
  return date ? date.slice(0, 10) : null
}
